import { DarkModeToggle as BaseDarkModeToggle } from '@dvb/ui';
import { useSettingStore } from '@milestone-portal/context/useSettingStore';

interface Props {
  className?: string;
  isSwitchOnly?: boolean;
}

export function DarkModeToggle({
  className = '',
  isSwitchOnly = false,
}: Props) {
  const { isDarkMode, toggleDarkMode } = useSettingStore();
  return (
    <BaseDarkModeToggle
      className={className}
      isDarkMode={isDarkMode}
      isSwitchOnly={isSwitchOnly}
      toggleDarkMode={toggleDarkMode}
    />
  );
}
